import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.1654 14.666C15.1654 14.9393 14.9387 15.166 14.6654 15.166H1.33203C1.0587 15.166 0.832031 14.9393 0.832031 14.666C0.832031 14.386 1.0587 14.166 1.33203 14.166H14.6654C14.9387 14.166 15.1654 14.386 15.1654 14.666Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.4",
  d: "M14.0021 6.65247V14.1658H1.96875L2.00209 6.6458C2.00209 6.23913 2.18875 5.8525 2.51542 5.59917L7.18208 1.9725C7.66208 1.5925 8.34209 1.5925 8.82209 1.9725L13.4888 5.59917C13.8154 5.8525 14.0021 6.23914 14.0021 6.65247Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 5.5H7C6.72667 5.5 6.5 5.27333 6.5 5C6.5 4.72667 6.72667 4.5 7 4.5H9C9.27333 4.5 9.5 4.72667 9.5 5C9.5 5.27333 9.27333 5.5 9 5.5Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.3346 7.33398H5.66797C5.11464 7.33398 4.66797 7.78065 4.66797 8.33398V14.6673H11.3346V8.33398C11.3346 7.78065 10.888 7.33398 10.3346 7.33398ZM7.16797 11.834C7.16797 12.1073 6.9413 12.334 6.66797 12.334C6.39464 12.334 6.16797 12.1073 6.16797 11.834V10.834C6.16797 10.5607 6.39464 10.334 6.66797 10.334C6.9413 10.334 7.16797 10.5607 7.16797 10.834V11.834Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WarehouseIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
}

})